import React, { FC } from 'react';
import Box from '../../../elements/Box';
import { BoxProps } from '../../../elements/Box/Box';

export interface LoadingDestinationProps extends BoxProps {
  label: string;
}

const LoadingDestination: FC<LoadingDestinationProps> = (props: LoadingDestinationProps) => {
  const { label, ...boxProps } = props;
  return <Box {...boxProps}>{label}</Box>;
};

export default LoadingDestination;
